import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { AuthenticationGuard } from './authentication/authentication.guard';
import { UnAuthenticationGuard } from './authentication/unauthentication.guard';
import { OrganisationSelectorComponent } from './components/organisation-selector/organisation-selector.component';
import { UserSelectorComponent } from './components/user-selector/user-selector.component';
import { HomeComponent } from './components/home/home.component';
import { OrganisationIndexComponent } from './components/organisation-index/organisation-index.component';
import { ProjectSelectorComponent } from './components/project-selector/project-selector.component';
import { PlayComponent } from './components/play/play.component';
import { RecorderComponent } from './components/recorder/recorder.component';
import { EditorComponent } from './element-editor/component/editor.component';
import { NewProjectComponentComponent } from './new/new-project-component/new-project-component.component';
import { ProjectOverviewComponent } from './project-overview/project-overview.component';
import { UserStoryChatbotComponent } from './new/user-story-chatbot/user-story-chatbot.component';
import { VideoQuestionnaireComponent } from './new/video-questionnaire/video-questionnaire.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/home',
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'organisations',
        children: [
          {
            path: '',
            component: OrganisationSelectorComponent,
          },
          {
            path: ':organisationID',
            children: [
              {
                path: '',
                component: OrganisationIndexComponent,
              },
              {
                path: 'settings',
                component: OrganisationIndexComponent,
              },
              {
                path: 'users',
                component: OrganisationIndexComponent,
              },
              {
                path: 'projects',
                children: [
                  {
                    path: '',
                    component: ProjectSelectorComponent,
                  },
                  {
                    path: ':projectID',
                    children: [
                      {
                        path: '',
                        component: EditorComponent,
                      },
                      {
                        path: 'file',
                        children: [
                          {
                            path: ':fileID',
                            children: [
                              {
                                path: '',
                                component: EditorComponent,
                              },
                              {
                                path: 'play',
                                data: {
                                  hideHeader: true,
                                },
                                component: PlayComponent,
                              },
                              {
                                path: 'record',
                                data: {
                                  hideHeader: true,
                                },
                                component: RecorderComponent,
                              },
                              // {
                              //   path: ':animationId',
                              //   component: EditorComponent,
                              // },
                              // {
                              //   path: '**',
                              //   redirectTo: '',
                              // },
                            ],
                          },
                        ],
                      },
                      {
                        path: '**',
                        redirectTo: '',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'users',
        component: UserSelectorComponent,
      },
      {
        path: 'new',
        component: NewProjectComponentComponent,
      },
      {
        path: 'chatbot',
        component: UserStoryChatbotComponent,
      },
      {
        path: 'chatbot/:customToken',
        component: UserStoryChatbotComponent,
      },
      {
        path: 'p/:projectID',
        component: ProjectOverviewComponent,
      },
      {
        path: 'lab',
        loadChildren: () =>
          import('./lab/lab.module').then(({ LabModule }) => LabModule),
      },
    ],
  },
  {
    path: '',
    canActivate: [UnAuthenticationGuard],
    children: [
      {
        path: 'signIn',
        component: SignInComponent,
      },
      {
        path: 'signUp',
        component: SignUpComponent,
      },
    ],
  },
  // Public route - no authentication required
  {
    path: 'quest/:customToken',
    component: VideoQuestionnaireComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
